import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fa5, faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { available_Staff, GetEventDeatils_AvailableStaffs, getEventList } from "../CrudOperations/GetOperation";







const AvailableDeputy = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredAvailableDeputyList, setFilteredAvailableDeputyList] = useState([]);
  const [AvailableDeputyList, setAvailableDeputyList] = useState([]);
  const [EventDetailId, setEventDeatilId] = useState("");


  const [eventDetailsList, setEventDetailsList] = useState([]);


  useEffect(() => {




    const fetchStaffs = async () => {


    // const response = await available_Staff()
    // console.log(response);
    

    // if(response.data.Message === "Success") {
    //     setAvailableDeputyList(response.data.AvailableStaff);
    //     setFilteredAvailableDeputyList(response.data.AvailableStaff);

    //  } 
     
    //  else {
    //    toast.error("Failed to fetch Staffs. Please try again.");
    //  }





    const response = await getEventList();
    console.log(response);

    if(response.data.Message === "Success") {
        setEventDetailsList(response.data.Data);

     }
     else {
       toast.error("Failed to fetch Staffs. Please try again.");
     }





    };
    fetchStaffs();
  }, []);

  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredList = AvailableDeputyList.filter(
      (p) =>
        p.StaffName.toLowerCase().includes(query)
    );
    setFilteredAvailableDeputyList(filteredList);
  };

  const handleEventDetailChange = async(e) => {


    const EventDetailsId = e.target.value;
    setEventDeatilId(EventDetailsId)

    const response = await GetEventDeatils_AvailableStaffs(EventDetailsId);
    console.log(response);

    setAvailableDeputyList(response?.data);
    setFilteredAvailableDeputyList(response?.data);



  }





  return (
    <div className="container mx-auto p-8 bg-white rounded-lg shadow-lg shadow-gray-300">
      <h1 className="text-xl font-inter font-bold mb-6 border-b-4 border-blue-600 pb-2 text-gray-800">
        Manage Available Deputy
      </h1>

      <div className="flex justify-between items-center mb-4">

      <div className="mb-6 w-full flex justify-between items-center">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInput}
          className=" border border-gray-300 px-2 py-1 mt-2 rounded-md transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        />
   
      </div>


{/* hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh */}


<div className="mb-2 w-full">
              <label className="block text-gray-700">Deputy & Skill*</label>
{console.log(eventDetailsList)
}
              <select
                value={EventDetailId}
                onChange={(e) => handleEventDetailChange(e)}
                className="border border-gray-300 p-1 w-full rounded-md"
              >
       
                <option value="">Select EventDetails</option>
                {eventDetailsList?.length > 0 &&
                  eventDetailsList.map((eve) => (
                    <option key={eve.EventDetailsId} value={eve.EventDetailsId}>
                      {eve.EventName}
                    </option>
                  ))}
              </select>
            </div>
     

     



      </div>

      {/* Responsive table wrapper */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white table-auto border border-gray-300 rounded-lg shadow-sm">
          <thead className="bg-gray-100">
            <tr>



              {[
                      "S.No",
                "Deputy Name",
                "Community",
             
              ].map((heading) => (
                <th
                  key={heading}
                  className="py-3 px-4 text-center font-semibold text-gray-700"
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
           { console.log(filteredAvailableDeputyList)}
            
            {filteredAvailableDeputyList.length > 0 ? (
              filteredAvailableDeputyList.map((p,index) => (
                <tr
                  key={p.id}
                  className="border-b transition-colors duration-200 hover:bg-gray-50"
                >
                               <td className="py-3 px-4 text-center">{index+1}</td>
                  <td className="py-3 px-4 text-center">{p.StaffName}</td>
                  <td className="py-3 px-4 text-center">{p.CommunityName}</td>

               
                </tr>
              ))
            ) : (
              <tr key={0}>
                <td colSpan="9" className="py-3 text-center text-gray-600">
                  No Staffs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>


    </div>
  );
};

export default AvailableDeputy;
